import React, { useEffect, useState } from "react";
import BASE_URL from "../../config";

export default function Gallery() {

  const [galleryData, setGalleryData] = useState([]);

  useEffect(() => {

    const fetchData = () => {
      fetch(`${BASE_URL}/api/getActivities.php?t=${Date.now()}`)
        .then(res => res.json())
        .then(data => {
          console.log(data); // 🔍 DEBUG
          setGalleryData(data);
        })
        .catch(err => console.error(err));
    };

    fetchData(); // first load

    const interval = setInterval(fetchData, 5000);

    return () => clearInterval(interval);

  }, []);

  return (
    <div className="gallery-page">
      <h1>અમારી પ્રવૃત્તિઓ</h1>

      <div className="gallery-container">
        {galleryData.length > 0 ? (
          galleryData.map((item) => (
            <div className="gallery-card" key={item.id}>
              
              <div className="gallery-img">
                <img
                  src={`${BASE_URL}/uploads/${item.image}`}
                  alt=""
                />
              </div>

            </div>
          ))
        ) : (
          <p>No images found</p>
        )}
      </div>
    </div>
  );
}